import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { Image } from '../../../assets';
import { useEffect, useState } from 'react';
import { post } from '../../../util/request';
import { useSelector } from 'react-redux';
import { userInfo } from '../../../redux/slice';

const BankAccountMFAPopUp = ({ isModalOpen, maskedEmail, referenceId, handleClose, handleSave, handleMFA, handleContactUs }) => {
    const { t } = useTranslation();
    const [code, setCode] = useState('');
    const user = useSelector(userInfo);
    const [invalidCode, setInvalidCode] = useState(false);

    const verify = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId,
            referenceId: referenceId,
            verificationCode: code
        };

        await post('/mfa/verify', params).then((data) => {
            if (data) {
                if (data.message === 'Success') {
                    handleClose();
                    handleSave();
                }
            }
            else {
                setInvalidCode(true);
            }
        });
    }

    const resend = async () => {
        setCode('');
        setInvalidCode(false);
        handleClose();
        handleMFA();
    }

    useEffect(() => {
        setCode('');
        setInvalidCode(false);
    }, []);


    const handleCancel = async () => {
        setCode('');
        setInvalidCode(false);
        handleClose();
    }

    return (
        <>
            <Modal
                open={isModalOpen}
                onCancel={handleCancel}
                footer=""
                centered
                width={688}
                classNames={{ body: 'custom-modal-body' }}
            >
                <div className="modal-box">
                    <img src={Image.waltonLogo} alt='' />
                    <div className="bank-account-mfa-popup-title">{t('Multi-factor Authentication')}</div>
                    <div className="text-center mfa-content">
                        <p>{t('A code has been sent to').replace('{email}', maskedEmail)}</p>
                        <p>{t('Enter code below, or')} <b onClick={() => resend()}>{t('send a new code')}</b></p>
                        <input type='text' value={code} onChange={(e) => setCode(e.target.value)} maxLength={6} />
                        {
                            invalidCode ? <p className='invalid-code'>{t('The verification code you have entered does not match our records. Please try again, or request a new code.')}</p> : ""
                        }
                    </div>
                    <div className="custom-modal-body mfa-send-button">
                        <button
                            type="button"
                            onClick={() => verify()}
                        >
                            {t('Verify Code')}
                        </button>
                    </div>


                    <div className='custom-modal-body mfa-customer-service'>
                        <p>{t('Have problem?')}</p>
                        <span onClick={() => handleContactUs()}> {t('Contact Customer Service')}</span>
                    </div>

                    <div className="custom-modal-body mfa-back">
                        <p
                            onClick={handleCancel}
                        >
                            {t('Back')}
                        </p>
                    </div>


                </div>

            </Modal >
        </>
    )
}
export default BankAccountMFAPopUp;